export const DEMO_OFFER = 'demoOffer';
export const WARM_UP = 'warmUp';
export const PACKAGE_EXPIRED = 'packageExpired';
export const GA_CHECK = 'gaCheck';
export const BLACK_FRIDAY_NOTIFIER = 'blackFriday';
